
const common = {
  // Navigation
  brand_story: "История бренда",
  our_philosophy: "Наша философия", 
  product_series: "Линейка продуктов",
  global_sourcing: "Глобальные поставки",
  start_journey: "Начать путешествие",
  
  // Hero Section
  hero_title: "Верните себе право на",
  hero_title_highlight: "молодость",
  hero_description: "LunaKey предоставляет самые эффективные суперфуды природы, научно созданные для интеграции в ваши ежедневные ритуалы, позволяя вам излучать блеск и вечную жизненную силу.",
  hero_cta: "Начните свое путешествие",
  
  // Story Section
  story_title: "От мифа к современности",
  story_subtitle: "От легенды к реальности",
  story_description_1: "В древних легендах богиня Луна танцевала с духовным оленем под лунным светом, охраняя секреты природы и жизненную силу. Эта мифическая сила теперь превращается в каждый продукт LunaKey через точную экстракцию современной науки.",
  story_description_2: "Мы придерживаемся философии 'Природа дает силу, наука подтверждает права', превращая самые драгоценные суперфуды мира в источники жизненной силы для вашей повседневной жизни через строгие научные процессы.",
  story_quote: "Мы не боремся со временем, а перестраиваем ваше право чувствовать молодость во времени.",
  
  // Philosophy Section
  philosophy_title: "Наша философия",
  philosophy_subtitle: "Система ценностей троицы, строящая ваш здоровый образ жизни",
  natures_proof: "Доказательство природы",
  natures_proof_subtitle: "Доказательство природы",
  natures_proof_description: "Высокоэффективные суперфуды, поставляемые со всего мира, без искусственных добавок. Каждый продукт несет в себе самую чистую силу природы, прошедшую строгий отбор и научную проверку.",
  empowered_confidence: "Уверенность через силу",
  empowered_confidence_subtitle: "Уверенность через силу",
  empowered_confidence_description: "Почувствуйте спокойствие и умиротворение, которые приходят от контроля над собственным здоровьем. Выбирая LunaKey, вы выбираете лучшие инвестиции и заботу о себе.",
  your_vitality: "Ваша жизненная сила, ваше право",
  your_vitality_subtitle: "Ваша жизненная сила, ваше право",
  your_vitality_description: "Манифест о проактивной заботе о себе и суверенитете здоровья. У вас есть право на лучшее состояние, право чувствовать бесконечную жизненную силу.",
  
  // Products Section
  products_title: "Ваши права, перестроенные здесь",
  products_subtitle: "Две основные линейки продуктов, обеспечивающие комплексную поддержку вашего здоровья и красоты",
  proof_series: "Серия доказательств прав",
  proof_series_subtitle: "Серия доказательств прав",
  proof_series_description: "Отобранные мировые премиальные суперфуды, предоставляющие самое сильное доказательство для вашего здоровья. Каждый продукт проходит строгий контроль качества, обеспечивая самое чистое питательное дополнение.",
  declaration_series: "Серия энергетических деклараций",
  declaration_series_subtitle: "Серия энергетических деклараций",
  declaration_series_description: "Решения для энергетического дополнения, разработанные для современного образа жизни, позволяющие поддерживать оптимальное состояние в напряженной повседневной жизни, демонстрируя внутреннее сияние и жизненную силу.",
  acai_powder: "Порошок асаи",
  acai_description: "Богат антиоксидантами, повышает иммунитет",
  white_tomato: "Порошок белого томата",
  white_tomato_description: "Натуральное отбеливание, сияние кожи",
  glow_booster: "Глоу Бустер",
  glow_description: "Внутреннее и внешнее совершенствование, естественное сияние",
  energy_elixir: "Энергетический эликсир",
  energy_description: "Устойчивая энергия, раскрытие безграничного потенциала",
  learn_more: "Узнать больше",
  
  // Sourcing Section
  sourcing_title: "По следам оленя",
  sourcing_subtitle: "Следуя по следам духовного оленя, исследуя происхождение самых драгоценных суперфудов мира",
  brazil: "Бразилия",
  brazil_ingredient: "Ягода асаи",
  brazil_description: "Фиолетовые драгоценности из глубин тропических лесов Амазонки, богатые антоцианами и антиоксидантами, код молодости, дарованный природой.",
  peru: "Перу",
  peru_ingredient: "Корень маки",
  peru_description: "Источник энергии с высокогорья Анд, тысячелетиями прославляемый как 'перуанский женьшень', вливающий в тело устойчивую жизненную силу.",
  himalaya: "Гималаи",
  himalaya_ingredient: "Ягоды годжи",
  himalaya_description: "Красные сокровища с крыши мира, взращенные в полярной среде сверхсильной жизненной силой, натуральное лекарство, питающее тело и душу.",
  mediterranean: "Средиземноморье",
  mediterranean_ingredient: "Лист оливы",
  mediterranean_description: "Зеленая эссенция под средиземноморским солнцем, несущая тысячелетнюю мудрость здоровья, приносящая чистую защиту современной жизни.",
  
  // Newsletter Section
  newsletter_title: "Получите руководство по обновлению жизненной силы",
  newsletter_description: "Подпишитесь на наш эксклюзивный контент, чтобы получать последнюю информацию о здоровье, обновления продуктов и профессиональные советы по питанию, начав свое путешествие к жизненной силе.",
  email_placeholder: "Ваш адрес электронной почты",
  subscribe: "Подписаться",
  subscribing: "Подписка...",
  subscribe_success: "Подписка успешна! Спасибо за присоединение к семье LunaKey.",
  subscribe_error: "Подписка не удалась, попробуйте позже.",
  privacy_notice: "Мы обещаем защищать вашу конфиденциальность и не будем делиться вашей информацией с третьими лицами. Вы можете отписаться в любое время.",
  
  // Footer
  quality_assurance: "Гарантия качества",
  about_us: "О нас",
  contact_us: "Связаться с нами",
  careers: "Карьера",
  faq: "Часто задаваемые вопросы",
  user_guide: "Руководство пользователя",
  customer_service: "Служба поддержки", 
  return_policy: "Политика возврата",
  footer_description: "Верните себе право на молодость, позвольте самым эффективным суперфудам природы интегрироваться в ваши ежедневные ритуалы, излучая блеск и вечную жизненную силу.",
  all_rights_reserved: "Все права защищены",
  privacy_policy: "Политика конфиденциальности",
  terms_of_service: "Условия обслуживания"
};

export default common;
